import { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import useAuth from "../utils/context/auth-context";

export function AuthGuard({ children }: { children: JSX.Element }) {
  const navigate = useNavigate();
  const location = useLocation();
  const isLink = location.pathname === "/auth/smartmatrix/link";
  const { auth, init } = useAuth();

  useEffect(() => {
    if (init && !auth && !isLink) {
      navigate("/auth/login");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth, init, isLink, navigate]);

  if (init && !auth && isLink) return <main className="mx-auto max-w-lg px-4 py-8">
    <h1 className="text-xl font-semibold">Restart account linking</h1>
    <p className="mt-3 text-sm">Your institute session is unavailable. Sign in with your institute password and restart linking from your profile.</p>
    <Link className="mt-4 block underline" to="/auth/login">Sign in to IMS</Link>
  </main>;
  return auth ? children : <></>;
}
export function ReversGuard({ children }: { children: JSX.Element }) {
  const navigate = useNavigate();
  const { auth } = useAuth();
  const location = useLocation();

  // Get authorization redirect
  const queryParams = new URLSearchParams(location.search);
  const platform = queryParams.get("platform");
  const clientId = queryParams.get("client_id");

  const linking = queryParams.get("smartmatrixLink") === "1";
  useEffect(() => {
    if (!auth) return;
    if (linking) navigate("/auth/smartmatrix/link?start=1", { replace: true });
    else if (platform === "pc" && clientId) navigate(`/authorize?platform=${platform}&client_id=${clientId}`, { replace: true });
    else navigate("/profile", { replace: true });
  }, [auth, linking, platform, clientId, navigate]);

  return !auth ? children : <></>;
}